/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import { API } from '@/redux/config/index';
import { toast } from 'react-toastify';
import { StnAPI } from '../config/customHeadersApi';
import { raiseErrorException } from '../../utils/raiseErrorException';
import {
  getCustomerReportStart,
  setAllCustomerReportQueue,
  setCreateMSSReportQueue,
  setCustomerReportQueue,
  setDownloadMSSReportQueue,
  setRedirectLink,
  setReducerError,
  setToggleMSSReportModal,
  start,
} from '../reducers/mssReportQueueReducer';

// Get report queue of customer
export const getCustomerReportQueue = (customerID, beginDate, endDate) => async (dispatch) => {
  dispatch(getCustomerReportStart());
  try {
    let endpoint = `/reportqueue/customer`;
    if (beginDate && endDate) {
      endpoint += `?beginDate=${beginDate}&endDate=${endDate}`;
    } else if (beginDate) {
      endpoint += `?beginDate=${beginDate}`;
    } else if (endDate) {
      endpoint += `?endDate=${endDate}`;
    }

    const response = await API.get(endpoint);

    dispatch(setCustomerReportQueue(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};

// Create MSS Report For Customer
export const createMSSReportForCustomer =
  (customerID, siteID, begindate, enddate, showAuto, showInternal, toggle) => async (dispatch) => {
    toast.info('We are generating your Report...');
    dispatch(start());
    toggle();

    try {
      const response = await StnAPI.post(
        '/reportqueue/mss',
        {
          customerID,
          siteID,
          begindate,
          enddate,
          showAuto,
          showInternal,
        },
        {
          responseType: 'blob',
        },
      );
      const header = response.headers['content-disposition'];
      let filename = header.substring(header.indexOf('"') + 1, header.lastIndexOf('"'));
      if (!filename) {
        filename = decodeURI(header.substring(header.lastIndexOf("'") + 1));
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);

      link.addEventListener('load', () => {
        window.URL.revokeObjectURL(url);
        link.remove();
      });

      document.body.appendChild(link);
      link.click();

      dispatch(setCreateMSSReportQueue(response.data));
      dispatch(getCustomerReportQueue(customerID));

      toast.success('Report Downloaded Successfully');
    } catch (error) {
      raiseErrorException(error, dispatch, setReducerError, 'post');
    }
  };

// redirect link for MSS Report For Customer
export const redirectLinkMSSReportForCustomer = () => async (dispatch) => {
  dispatch(start());
  try {
    const response = await API.get('/reportqueue/redirect');

    dispatch(setRedirectLink(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};

// Get All Report Queue
export const getAllReportQueue = () => async (dispatch) => {
  dispatch(start());
  try {
    const response = await API.get('/reportqueue');

    dispatch(setAllCustomerReportQueue(response.data));
  } catch (error) {
    raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};

export const downloadReport = (id) => async (dispatch) => {
  const downloadMessage = toast.info('Downloading Report...');
  dispatch(start());
  try {
    const response = await API.get(`/reportqueue/report/${id}`, {
      responseType: 'blob',
    });
    const header = response.headers['content-disposition'];
    let filename = header.substring(header.indexOf('"') + 1, header.lastIndexOf('"'));
    if (!filename) {
      filename = decodeURI(header.substring(header.lastIndexOf("'") + 1));
    }
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);

    link.addEventListener('load', () => {
      window.URL.revokeObjectURL(url);
      link.remove();
    });

    document.body.appendChild(link);
    link.click();

    dispatch(setDownloadMSSReportQueue(response.data));
    toast.update(downloadMessage, {
      render: 'Download Successful',
      type: 'success',
      isLoading: false,
      autoClose: 1000,
    });
  } catch (error) {
    dispatch(setReducerError(error.response?.data.detail));
    toast.update(downloadMessage, {
      render: `${error.response.data.detail}`,
      type: 'error',
      isLoading: false,
    });
    // raiseErrorException(error, dispatch, setReducerError, 'get');
  }
};

// Toggle the Modal that adds a customer
export const mssReportModalToggle = () => async (dispatch) => dispatch(setToggleMSSReportModal());
